/* eslint-disable @typescript-eslint/no-explicit-any */
// Third-party Imports
import { createSlice } from '@reduxjs/toolkit'

// Type Imports

// Data Imports

const initialState: any = {
  selectedEvent: null,
  selectedTypes: ['1', '2', '3', '4', '5']
}

export const sampleSlice = createSlice({
  name: 'sample',
  initialState: initialState,
  reducers: {
    filterEvents: state => {
      state.filteredEvents = state.events
    },

    addEvent: (state, action) => {
      const newEvent = { ...action.payload, id: `${parseInt(state.events[state.events.length - 1]?.id ?? '') + 1}` }

      state.events.push(newEvent)
    },

    selectedEvent: (state, action) => {
      state.selectedEvent = action.payload
    }
  }
})

export const { filterEvents, addEvent, selectedEvent } = sampleSlice.actions

export default sampleSlice.reducer
